<template>
  <GmbLayout :backgroundImagePath="backgroundImagePath">
    <header class="container-fluid z-index-1 px-0 gmb-l-header">
      <div
          class="d-flex p-1 justify-content-end align-items-center gmb-navbar gmb-navbar--transparent"
      >
        <b-nav id="nav" class="gmb-account-menu" pills>
          <b-nav-item
              href="https://geomob.fr/"
              link-classes="p-1 gmb-account-menu__item-link"
          >Qu'est-ce que Geomob ?
          </b-nav-item
          >
        </b-nav>
      </div>
    </header>

    <main
        class="d-flex z-index-0 container-fluid flex-grow-1 px-0 h-0 flex-column"
    >
      <div
          class="d-flex flex-grow-1 h-0 flex-column justify-content-center align-items-center"
      >
        <div
            class="d-flex my-5 rounded-1 p-5 flex-column bg-theme-1 gmb-block--authentication"
        >
          <GmbRow>
            <div class="d-flex my-4 align-items-center">
              <GmbBrandLogo isLarge/>
            </div>
          </GmbRow>

          <GmbDisplayHeading class="mt-3" text="Connexion"/>

          <form class="container-xl mt-3 px-0" @submit="onSubmit">
            <GmbRow>
              <FdText bold colorTheme4 tag="label">Identifiant :</FdText>
              <b-form-input
                  v-model="username"
                  class="mt-1"
                  name="username"
                  required
              />
            </GmbRow>

            <GmbRow class="mt-2">
              <FdText bold colorTheme4 tag="label">Mot de passe :</FdText>
              <b-form-input
                  v-model="password"
                  class="mt-1"
                  name="password"
                  required
                  type="password"
              />
            </GmbRow>

            <div class="d-flex mt-3"/>
            <GmbRow class="mt-3">
              <b-button
                  class="d-flex py-1 px-4 justify-content-center align-items-center text-size-reset rounded-1"
                  type="submit"
                  variant="primary"
              >Connexion
              </b-button
              >
            </GmbRow>
          </form>

          <div class="d-flex pt-3 px-2 flex-column">
            <p class="text-center"><a :href="passwordResetUrl">Créer ou réinitialiser mon mot de passe</a></p>
          </div>

          <div class="d-flex pt-3 flex-column">
            <GmbCopyrightRow isAlignedCenter/>
          </div>
        </div>
      </div>
    </main>
  </GmbLayout>
</template>

<script>
import {login} from "@/services/authentication";
import router from "@/router";

import FdText from "@/flexdesign/Text";
import GmbBrandLogo from "@/widgets/BrandLogo";
import GmbCopyrightRow from "@/widgets/CopyrightRow";
import GmbDisplayHeading from "@/widgets/DisplayHeading";
import GmbLayout from "@/widgets/Layout";
import GmbRow from "@/widgets/Row";
import {BACKEND_API_URL, networkErrorHandler} from "@/services/base";

export default {
  name: "GmbAuthentication",

  components: {
    FdText,
    GmbBrandLogo,
    GmbCopyrightRow,
    GmbDisplayHeading,
    GmbLayout,
    GmbRow,
  },

  props: {},

  data() {
    return {
      backgroundImagePath: require("@/assets/background_authentication.png"),

      username: "",
      password: "",

      submissionInProgress: false,

      passwordResetUrl: new URL("backoffice/auth/reset-password/", BACKEND_API_URL).href,
    };
  },

  computed: {},

  watch: {},

  beforeCreate() {
  },

  created() {
  },

  beforeMount() {
  },

  mounted() {
  },

  beforeUpdate() {
  },

  updated() {
  },

  beforeUnmount() {
  },

  unmounted() {
  },

  methods: {
    onSubmit(event) {
      event.preventDefault();

      // Prevent double submit and its errors
      if (this.submissionInProgress) return;
      this.submissionInProgress = true;

      if (this.username != "" && this.password != "") {
        login(this.username, this.password)
            .then((res) => router.push("/"))
            .catch((error) => {
              if (error.response && error.response.status == 400) {
                alert("Identifiants invalides")
              } else if (error.response && error.response.status == 403) {
                alert("Trop de tentatives échouées, veuillez réessayer plus tard")
              }
              else {
                networkErrorHandler(error);
              }
            })
            .finally(() => {
              this.submissionInProgress = false;
            });
      } else {
        alert("Please fill login and password fields!"); // not used anymore if form validation blocks submit anyway
      }
    },
  },
};
</script>

<style lang="scss"></style>
